module.exports = __webpack_public_path__ + "img/xinzeng.71fbf128.jpg";